<template>
  <v-container fluid class="pa-4">
    <v-card>
      <v-data-table :headers="headers" :items="levels">
        <template #[`item.color`]="{ item }">
          <v-chip :color="item.color" text-color="white" small>{{ item.color }}</v-chip>
        </template>
        <template #[`item.range`]="{ item }">{{ item.minScore }} – {{ item.maxScore }}</template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex';
import { getLevels } from '../../api/sac';

export default {
    name: 'SacScoreLevels',
    data() {
        return {
            levels: [],
            headers: [
                { text: 'Nivel', value: 'name' },
                { text: 'Rango', value: 'range' },
                { text: 'Color', value: 'color' },
                { text: 'Recomendación', value: 'recommendation' },
            ],
        };
    },
    methods: {
        ...mapMutations('notification', ['show']),
    },
    async mounted() {
        try {
            const r = await getLevels();
            this.levels = r.levels || [];
        } catch (e) {
            this.show({
                text: e?.response?.data?.error?.message || e?.response?.data?.message || e.message || 'No se pudieron cargar los niveles',
                color: 'error',
            });
        }
    },
};
</script>
